import React, { useState } from 'react';
import MessageSectionInspector from './MessageSectionInspector';
import './DressCodeSectionInspector.css';

function DressCodeSectionInspector({ 
  func, 
  index, 
  onUpdate,
  isIconPickerOpen,
  setIsIconPickerOpen,
  iconPickerPosition,
  setIconPickerPosition,
  setActiveIconPreview,
  bringToFront
}) {
  const [expandedSections, setExpandedSections] = useState({
    top: false,
    colors: false,
    bottom: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleColorChange = (colorIndex, value) => {
    const newColors = [...((func.props.colorProp && func.props.colorProp.colors) || [])];
    newColors[colorIndex] = value;
    onUpdate(index, { 
      ...func.props, 
      colorProp: {
        ...func.props.colorProp,
        colors: newColors
      }
    });
  };

  const addColor = () => {
    const newColors = [...((func.props.colorProp && func.props.colorProp.colors) || []), '#000000'];
    onUpdate(index, { 
      ...func.props, 
      colorProp: {
        ...func.props.colorProp,
        colors: newColors
      }
    });
  };

  const removeColor = (colorIndex) => {
    const newColors = func.props.colorProp.colors.filter((_, idx) => idx !== colorIndex);
    onUpdate(index, { 
      ...func.props, 
      colorProp: {
        ...func.props.colorProp,
        colors: newColors
      }
    });
  };

  const handleSvgPropChange = (prop, value) => {
    console.log('DressCode - Updating SVG prop:', prop, 'to:', value);
    console.log('DressCode - Current props:', func.props);
    
    // Always force viewBox to be "0 0 24 24"
    let finalValue = value;
    if (prop === 'viewBox') {
      finalValue = "0 0 24 24";
      console.log('DressCode - Forcing viewBox to:', finalValue);
    }
    
    const updatedProps = {
      ...func.props,
      colorProp: {
        ...func.props.colorProp,
        svg: {
          ...(func.props.colorProp?.svg || {}),
          [prop]: finalValue
        }
      }
    };
    
    console.log('DressCode - Updated props:', updatedProps);
    onUpdate(index, updatedProps);
  };

  return (
    <div className="dcs-root">
      <div className="dcs-section">
        <div className="dcs-header" onClick={() => toggleSection('top')}>
          <h3>Top Message</h3>
          <button className={`dcs-collapse ${expandedSections.top ? 'expanded' : ''}`}>
            ▼
          </button>
        </div>
        <div className={`dcs-body ${expandedSections.top ? 'expanded' : ''}`}>
          <MessageSectionInspector
            func={{ name: 'TopMessageSection', props: func.props.topMessageProps || {} }}
            index={`${index}-top`}
            onUpdate={(i, updatedProps) => {
              // Get the latest props from the parent to ensure we have the latest state
              const latestProps = {
                ...func.props,
                topMessageProps: {
                  ...(func.props.topMessageProps || {}),
                  ...updatedProps
                }
              };
              onUpdate(index, latestProps);
            }}
            isIconPickerOpen={isIconPickerOpen}
            setIsIconPickerOpen={setIsIconPickerOpen}
            iconPickerPosition={iconPickerPosition}
            setIconPickerPosition={setIconPickerPosition}
            setActiveIconPreview={setActiveIconPreview}
            bringToFront={bringToFront}
          />
        </div>
      </div>

      <div className="dcs-section">
        <div className="dcs-header" onClick={() => toggleSection('colors')}>
          <h3>Colors</h3>
          <button className={`dcs-collapse ${expandedSections.colors ? 'expanded' : ''}`}>
            ▼
          </button>
        </div>
        <div className={`dcs-body ${expandedSections.colors ? 'expanded' : ''}`}>
          {/* SVG Preview and Properties */}
          <div className="icon-section">
            <div className="icon-inputs">
              <div className="input-group">
                <label>ViewBox</label>
                <input
                  type="text"
                  value={func.props.colorProp?.svg?.viewBox || "0 0 24 24"}
                  onChange={(e) => handleSvgPropChange('viewBox', e.target.value)}
                  placeholder="e.g. 0 0 24 24"
                  className="full-width-input"
                />
              </div>
              <div className="input-group">
                <label>SVG Path</label>
                <input
                  type="text"
                  value={func.props.colorProp?.svg?.d || "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"}
                  onChange={(e) => handleSvgPropChange('d', e.target.value)}
                  placeholder="SVG path data"
                  className="full-width-input"
                />
              </div>
            </div>
            <div 
              className="icon-preview"
              onClick={(e) => {
                console.log('DressCode color SVG preview clicked');
                // Store the index with a special prefix to identify it as a dress code svg
                setActiveIconPreview({ 
                  index: `dress-${index}`
                });
                setIsIconPickerOpen(true);
                bringToFront('iconPicker');
                e.stopPropagation();
              }}
              title="Click to change icon"
            >
              <svg
                viewBox={func.props.colorProp?.svg?.viewBox || "0 0 24 24"}
                className="preview-svg"
                style={{ verticalAlign: 'middle' }}
              >
                <path
                  d={func.props.colorProp?.svg?.d || "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"}
                  fill="none"
                  stroke="#000"
                  strokeWidth="1"
                />
              </svg>
            </div>
            <div className="input-group input-group-checkbox">
              <div className="toggle-label">
                Add Border to SVG
                <div className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={func.props.colorProp?.svg?.border === "true"}
                    onChange={(e) => handleSvgPropChange('border', e.target.checked ? "true" : "false")}
                  />
                  <span className="toggle-slider" onClick={(e) => {
                    const newValue = func.props.colorProp?.svg?.border !== "true";
                    handleSvgPropChange('border', newValue ? "true" : "false");
                  }}></span>
                </div>
              </div>
            </div>
          </div>

          {/* Color List */}
          <div className="dcs-colors">
            <h4>Color List</h4>
            {((func.props.colorProp && func.props.colorProp.colors) || []).map((color, colorIndex) => (
              <div key={colorIndex} className="dcs-color-item">
                <div className="dcs-color-inputs">
                  <input
                    type="color"
                    value={color}
                    onChange={(e) => handleColorChange(colorIndex, e.target.value)}
                    className="dcs-picker"
                  />
                  <input
                    type="text"
                    value={color}
                    onChange={(e) => handleColorChange(colorIndex, e.target.value)}
                    placeholder="#000000"
                    className="dcs-input"
                  />
                </div>
                <button 
                  onClick={() => removeColor(colorIndex)}
                  className="dcs-remove"
                  title="Remove color"
                >
                  ×
                </button>
              </div>
            ))}
            <button 
              onClick={addColor}
              className="dcs-add"
            >
              + Add Color
            </button>
          </div>
        </div>
      </div>

      <div className="dcs-section">
        <div className="dcs-header" onClick={() => toggleSection('bottom')}>
          <h3>Bottom Message</h3>
          <button className={`dcs-collapse ${expandedSections.bottom ? 'expanded' : ''}`}>
            ▼
          </button>
        </div>
        <div className={`dcs-body ${expandedSections.bottom ? 'expanded' : ''}`}>
          <MessageSectionInspector
            func={{ name: 'BottomMessageSection', props: func.props.bottomMessageProps || {} }}
            index={`${index}-bottom`}
            onUpdate={(i, updatedProps) => {
              // Get the latest props from the parent to ensure we have the latest state
              const latestProps = {
                ...func.props,
                bottomMessageProps: {
                  ...(func.props.bottomMessageProps || {}),
                  ...updatedProps
                }
              };
              onUpdate(index, latestProps);
            }}
            hideIconBool={true}
            hideTitleBool={true}
            isIconPickerOpen={isIconPickerOpen}
            setIsIconPickerOpen={setIsIconPickerOpen}
            iconPickerPosition={iconPickerPosition}
            setIconPickerPosition={setIconPickerPosition}
            setActiveIconPreview={setActiveIconPreview}
            bringToFront={bringToFront}
          />
        </div>
      </div>
    </div>
  );
}

export default DressCodeSectionInspector;
